import { createAction, props } from "@ngrx/store";
import { PaginationRequest } from "src/app/models/common/paginationRequest";

export const getCurrentTenantFormatList = createAction(
  "[Tenant] Get Current Tenant Data Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadCurrentTenantFormatList = createAction(
  "[Tenant] Load Current Tenant Data Action",
  props<{ response: any[] }>()
);

export const getTenant = createAction(
  "[Tenant] Get Tenant Data Action",
  props<{ code: string }>()
);
export const loadTenant = createAction(
  "[Tenant] Load Tenant Data Action",
  props<{ result: any }>()
)

export const updateTenant = createAction(
  "[Tenant] Update Tenant Action",
  props<{ tenant: any; logoutAfterUpdate?: boolean }>()
);

export const setTimezone = createAction(
  "[Tenant] Set Timezone Action",
  props<{ timezone: string }>()
);

export const setLoadingEndState = createAction("[Tenant] Load End Action");
